// @ts-nocheck
import { getDatabase, ref, get, child, update } from 'firebase/database';
import { IUserData } from '../../common/common-types';
import { Tables, API_BASE_URL } from '../../common/constants';
import axios from 'axios';
import { PropertyItem } from '../realtime-db/users/users.types';

export default class User {
  getUserCards({ id, userId }: { id: string; userId: string }) {
    const dbRef = ref(getDatabase());
    return get(child(dbRef, `users/${userId}/${id}`))
      .then((ss) => {
        if (!ss.exists()) return null;
        return ss.val();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getUserAccounts = async (userId: string): Promise<{ [accountId: string]: PropertyItem[] }> => {
    const dbRef = ref(getDatabase());
    return get(child(dbRef, `users/${userId}`)).then((ss) => {
      if (!ss.exists()) return [];
      const val: { [k: string]: string } = ss.val();
      delete val['test'];
      // console.log('--- val', val);
      return val;
      // return Object.entries(val).filter(([key]) => key !== 'test');
    });
  };
}
